import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import { getMessaging, getToken, isSupported } from 'firebase/messaging';

const firebaseConfig = JSON.parse(process.env.REACT_APP_FIREBASE_MESSAGING_CONFIG || '{}');

// Initialize Firebase
const firebaseApp = firebase.initializeApp(firebaseConfig);

const requestNotificationPermission = async () => {
  // Check if we're in a secure context before requesting permission
  if (!window.isSecureContext) {
    console.warn('Notifications require a secure context (HTTPS or localhost).');
    return false;
  }

  // Check if the Notification API is supported
  if (!('Notification' in window)) {
    console.warn('This browser does not support notifications.');
    return false;
  }

  try {
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      console.warn('Notification permission not granted.');
      return false;
    }
    return true;
  } catch (error) {
    console.error('Error requesting notification permission:', error);
    return false;
  }
};

const getFirebaseToken = async () => {
  const hasPermission = await requestNotificationPermission();
  if (!hasPermission) {
    console.warn('Notification permission not granted.');
    return '';
  }

  const isWindowSupported = await isSupported();
  // Check if messaging is supported in this browser
  if (!isWindowSupported) {
    console.warn('Firebase messaging is not supported in this browser.');
    return '';
  }

  try {
    const messaging = getMessaging(firebaseApp);
    const token = await getToken(messaging, {
      //prod
      // vapidKey: 'BAt_qE_cCkLjrx0BroqaH9DqnohMpy90Y3JFwHKcjYS1qHH_VE5AtzDAhosutfU6sng7tL-wAj07w2XncXtw5H0',
      //test
      vapidKey: 'BPA7IPHpcWZbpKeYzRZenbgLWcUaaCvkvcrmkreIHSsIcbeRsjZWZt3iv10Ru9AbyD3Fyughukp905hT46Cjwwo',
    });
    if (!token) {
      console.warn('No registration token available. Request permission to generate one.');
    }
    return token;
  } catch (err) {
    console.error('An error occurred while retrieving token.', err);
    return '';
  }
};

const db = firebaseApp.firestore();

export { db, getFirebaseToken };
